module.exports = __webpack_public_path__ + "media/images/ln/constellation_05-2ab6228e48400883a015809e0262cf63.png";